module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"snowflakeCloudAccountsTable.orgName":"Organization","snowflakeCloudAccountsTable.accountName":"Account","snowflakeCloudAccountsTable.noData":"No snowflake cloud connections configured.","snowflakeCloudAccountsTable.disconnectedUsageConnection":"Please update your usage connection with valid credentials"}}')
  delete Component.options._Ctor
}
